import type { GetRequiredInfoResponse } from '../get';
import {
	postGenericEndpoint,
	type PostGenericEndpointParams,
} from './post.api';
import type { PostRequiredInfoRequest } from './types';

export const postRequiredInfo = async ({
	data,
	lang,
	token,
}: PostGenericEndpointParams<PostRequiredInfoRequest>): Promise<GetRequiredInfoResponse> => {
	return await postGenericEndpoint({
		data,
		lang,
		token,
		path: 'signin/required-info',
	});
};
